// Zero-height sentinel that opens a room on the homepage: anchor target, Rail position, Aperture boundary.
export const RoomStart = ({ id }) => (
  <div id={`room-${id}`} data-room-boundary={id} data-testid={`room-start-${id}`} aria-hidden="true" className="h-0 w-full" />
);
